import Controller from 'controllers/controller';
import Helpers from 'tools/helpers';
import Binder from 'tools/binder';

class HomeController extends Controller {
    constructor(app) {
        super(app);
        
        this.root = document.querySelector('.page[data-template="home"]');
        this.binder = new Binder(this);

        this.autoplaySupported = false;
        
        this.elements = { };

        this.app.loaderController.on('home-loaded', () => {
            this.cacheElements();
            this.hideVideoIfNotAutoplaying();
            this.handleTemporaryLogo();
            this.handleCTA();
            this.addEvents();
        })
    }
    
    cacheElements() {
        this.elements.homePageVideo = this.root.querySelector('.home-page-video');
        this.elements.logoOverlay = this.root.querySelector('.logo-overlay');
        this.elements.temporaryLogo = this.root.querySelector('.temporary-logo');
        this.elements.cta = this.root.querySelector('.call-to-action-overlay');
        this.elements.ctaMobile = this.root.querySelector('.call-to-action-overlay-mobile');
        this.elements.defaultLogo = this.root.querySelector('.default-logo');
        this.elements.webLinkButtons = Array.from(this.root.querySelectorAll('.web-link'));
    }

    addEvents() {
        this.elements.webLinkButtons.forEach(button => {
            button.addEventListener('click', this.binder.bind('onWebLinkClick'));
        });
    }

    onWebLinkClick(event) {
        event.preventDefault();

        let link = event.currentTarget,
          url = link.getAttribute('href');

        this.app.pageController.scrollToPage(
          this.app.pageController.getPageByUrl(url)
        );
    }

    hideVideoIfNotAutoplaying() {
        let videoIsAutoplaying = false;
        
        if (this.elements.homePageVideo) {
            Helpers.repeat((current, max) => {
                if (this.elements.homePageVideo.paused) {
                    try {
                        this.elements.homePageVideo.play();
                    } catch (error) {
                        console.error('Failed to autoplay video');
                        console.error(error);
                    }
                } else {
                    videoIsAutoplaying = true;
                }
                
                console.log(videoIsAutoplaying, this.elements.homePageVideo);
                
                // On last iteration
                if (current === max) {
                    this.setVideo(videoIsAutoplaying);
                }
            }, 200, 3);
        }
    }

    handleTemporaryLogo() {
        if (this.elements.temporaryLogo) {
            const startDate = parseInt(this.elements.temporaryLogo.getAttribute('data-start-date'), 10);
            const endDate = parseInt(this.elements.temporaryLogo.getAttribute('data-end-date'), 10);

            const now = Date.now();

            if (now > startDate && now < endDate) {
                this.elements.logoOverlay.classList.add('show-temporary-logo');
            }
        }

        this.elements.logoOverlay.classList.add('is-loaded');
    }
    
    handleCTA() {
        if (this.elements.cta) {
            const startDate = parseInt(this.elements.cta.getAttribute('data-start-date'), 10);
            const endDate = parseInt(this.elements.cta.getAttribute('data-end-date'), 10);

            const now = Date.now();
            
            if (now > startDate && now < endDate) {
                this.elements.cta.classList.add('show-cta');
                this.elements.ctaMobile.classList.add('show-cta');
            }
        }

        this.elements.cta.classList.add('is-loaded');
        this.elements.ctaMobile.classList.add('is-loaded');
    }

    playVideo() {
        if (this.elements.homePageVideo) {
            this.elements.homePageVideo.play();
        }
    }
    
    pauseVideo() {
        if (this.elements.homePageVideo) {
            this.elements.homePageVideo.pause();
        }
    }

    onPageChange(page) {
        if (page.name === 'home') {
            this.playVideo();
        } else {
            this.pauseVideo();
        }
    }
    
    setVideo(isAutoplaying) {
        if (isAutoplaying) {
            this.autoplaySupported = isAutoplaying;
            this.app.pageController.on('change', this.binder.bind('onPageChange'));
        } else {
            this.elements.homePageVideo.style.display = 'none';
        }
    }
}

export default HomeController;